import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { selectOrganization } from '../../modules/organizations.js';
import Tabs from '../Tabs.jsx';
import AuthorizedAction, { isAuthorized } from '../AuthorizedAction.js';
import { selectUserPermissions } from '../../modules/auth.js';
import {
  CustomSettingsLink,
  OrganizationEmployeesLink,
  OrganizationLink,
  OrganizationStakeholdersLink,
  OrganizationUsersLink,
} from '../links/index.jsx';

const mapStateToProps = (state) => ({
  organization: selectOrganization(state),
  permissions: selectUserPermissions(state),
});

const mapDispatchToProps = {};

const OrganizationTabs = ({ permissions, organization }) => {
  return (
    <Tabs>
      <Tabs.Tab label="Organization Structure">
        <OrganizationLink>Organization Structure</OrganizationLink>
      </Tabs.Tab>
      <AuthorizedAction action="read" subject="organizationStakeholder">
        <Tabs.Tab label="Organization Stakeholders">
          <OrganizationStakeholdersLink>
            Organization Stakeholders
          </OrganizationStakeholdersLink>
        </Tabs.Tab>
      </AuthorizedAction>

      <AuthorizedAction action="read" subject="employee">
        <Tabs.Tab label="Employees">
          <OrganizationEmployeesLink>Employees</OrganizationEmployeesLink>
        </Tabs.Tab>
      </AuthorizedAction>

      <Tabs.Tab label="Users">
        <OrganizationUsersLink>Users</OrganizationUsersLink>
      </Tabs.Tab>
      {organization &&
      organization.canManageCustomSettings &&
      (isAuthorized('update', 'dynamicCategory', permissions) ||
        isAuthorized('manage', 'all', permissions)) ? (
        <Tabs.Tab label="Custom Settings">
          <CustomSettingsLink>Custom Settings</CustomSettingsLink>
        </Tabs.Tab>
      ) : null}
    </Tabs>
  );
};

OrganizationTabs.propsTypes = {
  project: PropTypes.shape({
    id: PropTypes.number.isRequired,
  }).isRequired,
};
export default connect(mapStateToProps, mapDispatchToProps)(OrganizationTabs);
